var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecorativeStrokeRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 144,
    viewBox: "0 0 471 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 123.194C33.5064 118.167 47.0356 113.039 60.6933 108.433C94.2185 97.1282 128.417 86.5883 162.427 76.9158C252.702 51.2412 346.192 26.6086 440.298 21.2616C508.549 17.3838 574.14 22.7645 641.571 33.0308C699.816 41.8986 760.121 50.6091 816.512 67.9393C861.421 81.7404 905.408 95.1312 952.556 99.4567C984.43 102.381 1020.86 105.919 1052.29 98.0603",
    stroke: "#6429CD",
    strokeWidth: 40,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorativeStrokeRight);
export default __webpack_public_path__ + "static/media/decorativeStrokeRight.1396601c43b3a2a9b5b4b7d0cf5ac6b1.svg";
export { ForwardRef as ReactComponent };